<ng-container *ngIf="isArray else notArray">
    <span class="se-ui-datagrid-ellipsis_box"
          [ngClass]="(viewValueArray.length > 1) ? 'se-ui-datagrid-ellipsis_multi' : 'se-ui-datagrid-ellipsis_single'"
          [ngStyle]="{'border-bottom' : isInvalid === true ? '2px solid red' : 'initial'}"
          [matTooltip]="viewValueArray.join('\n')"
          [matTooltipDisabled]="disabled"
          matTooltipClass='se-ui-datagrid-tooltip_multi'>
        <span #cellContent
              class="se-ui-datagrid-ellipsis_truncate"
              *ngFor="let item of viewValueArray">
            {{item}}
            <br />
        </span>
    </span>
</ng-container>

<ng-template #notArray>
    <div class="se-ui-datagrid-ellipsis_box se-ui-datagrid-ellipsis_single"
         [ngStyle]="{'border-bottom' : isInvalid === true ? '2px solid red' : 'initial'}"
         [matTooltip]="viewValue"
         [matTooltipDisabled]="disabled">
        <span #cellContent class="se-ui-datagrid-ellipsis_truncate">
            {{viewValue}}
        </span>
    </div>
</ng-template>

<!-- Validazione -->
<span *ngIf="formGroup" [formGroup]="formGroup">
    <input type="hidden"
           [formControlName]="key"
           [id]="key">
</span>
<!-- Fine Validazione -->
